import type { TaskCreation } from "../store/managers/TaskCreationManager"

export type TaskCreationDisplayPhase = TaskCreation["phase"] | "error"

export function getTaskCreationPhaseLabel(phase: TaskCreationDisplayPhase): string {
    if (phase === "pending") return "Starting..."
    if (phase === "completing") return "Starting task"
    return "Setup failed"
}
